import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

export const fncPopulateBranches = ({ commit, dispatch, state, rootState }, payload) => {
	if (state.branchList == '' || (payload != undefined && payload.reload == true) || (payload != undefined && payload.refresh == true)) {

		if( payload != undefined && payload != '' ) {
      var branchDetails = { manu_id: payload };
    } else {
      var objAuth = JSON.parse(rootState.objAuthorize);
      var branchDetails = { manu_id: objAuth.manufacturer };
    }

		Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Branch.php?a=retrieve', branchDetails, rootState.headerDetails)
			.then(response => {
				return response.json();
			}, error => {
				console.log(error);
			}).then(data => {
				commit('setBranchList', data);
				if (payload != undefined && payload.reload == true) {
					var snackDetails = { color: 'success', message: 'Branch reload successfull', display: true };
					commit('setSnack', snackDetails);
				}
			});
	}
};

export const fncPopulateBranchesMin = ({ commit, dispatch, state, rootState }, payload) => {
  if (state.branchList == '' || (payload != undefined && payload.reload == true) || (payload != undefined && payload.refresh == true)) {

    if( payload != undefined && payload != '' ) {
      var branchDetails = { manu_id: payload };
    } else {
      var objAuth = JSON.parse(rootState.objAuthorize);
      var branchDetails = { manu_id: objAuth.manufacturer };
    }

    Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Branch.php?a=retrieve_short', branchDetails, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        console.log(error);
      }).then(data => {
      commit('setBranchList', data);
      if (payload != undefined && payload.reload == true) {
        var snackDetails = { color: 'success', message: 'Branch reload successfull', display: true };
        commit('setSnack', snackDetails);
      }
    });
  }
};

export const fncBranchDelete = ({ commit, dispatch, state, rootState }, payload) => {
	var objAuth = JSON.parse(rootState.objAuthorize);
	var branchDetails = { id: payload.branchId };
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Branch.php?a=remove', branchDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			console.log(error);
		}).then(data => {
			if (data == 'success') {
				var snackDetails = { color: 'success', message: 'The branch was removed successfully', display: true };
				commit('setSnack', snackDetails);
				commit('fncEmptyBranches');
				dispatch({
					type: 'fncPopulateBranches',
					refresh: true
				});
			} else {
				var snackDetails = { color: 'error', message: 'An error has occured removing the branch', display: true };
				commit('setSnack', snackDetails);
			}
		});
};

export const fncAddBranch = ({ commit, dispatch, state, rootState }, payload) => {
	var objAuth = JSON.parse(rootState.objAuthorize);
	var regions = [];
	var userRegions = payload.branchDetails.branchRegions;

	for (var c in userRegions) {
		if (userRegions[c].selected == true) {
			regions.push(userRegions[c].loc_id);
		}
		for (var p in userRegions[c].children) {
			if (userRegions[c].children[p].selected == true) {
				regions.push(userRegions[c].children[p].loc_id);
			}
			for (var t in userRegions[c].children[p].children) {
				if (userRegions[c].children[p].children[t].selected == true) {
					regions.push(userRegions[c].children[p].children[t].loc_id);
				}
			}
		}
	}
	var branchDetails = {
		params: {
			name: payload.branchDetails.branchName,
			description: payload.branchDetails.branchDescription,
			addressOne: payload.branchDetails.branchAddressOne,
			addressTwo: payload.branchDetails.branchAddressTwo,
			postalCode: payload.branchDetails.branchPostalCode,
			contact: payload.branchDetails.branchContact,
			email: payload.branchDetails.branchEmail,
			terms: payload.branchDetails.branchTnc,
      switch: payload.branchDetails.branchSwitch,
			regions: regions,
			manufacturer: objAuth.manufacturer,
      user: objAuth.id,
			logo: state.branchLogo,
			code: payload.branchDetails.branchCode,
			bankName: payload.branchDetails.branchBankName,
			bankCode: payload.branchDetails.branchBankCode,
			bankAccount: payload.branchDetails.branchBankAccountNumber,
			bankAccountType: payload.branchDetails.branchBankAccountType,
      branchPricelist: payload.branchDetails.branchPricelist,
      trade_rep: payload.branchDetails.branchTradeRep
		}
	}

	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Branch.php?a=create', branchDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			console.log(error);
		}).then(data => {
			if (data == 'success') {
				commit('hideModal');
				var snackDetails = { color: 'success', message: 'The branch was added successfully', display: true };
				commit('setSnack', snackDetails);
				commit('fncEmptyBranches');
				/*dispatch({
					type: 'fncPopulateBranches',
					refresh: true
				});*/
        setTimeout(function() {
          location.reload();
        },1000)
			} else {
				var snackDetails = { color: 'error', message: 'An error has occured adding the branch', display: true };
				commit('setSnack', snackDetails);
			}
	});
};

export const fncUpdateBranch = ({ commit, dispatch, state, rootState }, payload) => {
	var objAuth = JSON.parse(rootState.objAuthorize);
	var regions = [];
	var userRegions = payload.branchDetails.branchRegions;
	for (var c in userRegions) {
		if (userRegions[c].selected == true) {
			regions.push(userRegions[c].loc_id);
		}
		for (var p in userRegions[c].children) {
			if (userRegions[c].children[p].selected == true) {
				regions.push(userRegions[c].children[p].loc_id);
			}
			for (var t in userRegions[c].children[p].children) {
				if (userRegions[c].children[p].children[t].selected == true) {
					regions.push(userRegions[c].children[p].children[t].loc_id);
				}
			}
		}
	}
	state.objBranchEdit.logo = state.branchLogo;
	var branchDetails = {
		params: {
        branch: state.objBranchEdit,
        storeDepartmentPricelist: payload.branchDetails.storeDepartmentPricelist,
        regions: regions,
        user: objAuth.id,
        trade_rep: state.objBranchEdit.trade_rep
		}
	}

	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Branch.php?a=update', branchDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			console.log(error);
		}).then(data => {
			if (data == 'success') {
				commit('hideModal');
				var snackDetails = { color: 'success', message: 'The branch was updated successfully', display: true };
				commit('setSnack', snackDetails);
				commit('fncEmptyBranches');
				/*dispatch({
					type: 'fncPopulateBranches',
					refresh: true
				});*/
        setTimeout(function() {
          location.reload();
        },1000)
			} else {
				var snackDetails = { color: 'error', message: 'An error has occured updating the branch', display: true };
				commit('setSnack', snackDetails);
			}
		});
};

export const fncUploadBranchLogo = ({ commit, dispatch, state, rootState }, payload) => {
	var uploadData = new FormData();
	var objAuth = JSON.parse(rootState.objAuthorize);
	var randInt = Math.floor((Math.random() * 9999) + 1000);
	uploadData.append('fileInput', payload.files, payload.files.name);
  uploadData.append('manufacturerID', objAuth.manufacturer);
  //uploadData.append('allowed_types', objAuth.allowed_file_types);
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'QuoteAttachment.php', uploadData, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = { color: 'error', message: 'An error occured while trying to upload the quote file', display: true };
			commit('setSnack', snackDetails);
		}).then(data => {

			var imgUrl = window.location.protocol + process.env.DEV_ENDPOINT + 'attachments/' + data.file_name;

			commit('setBranchLogo', imgUrl);

	});

	/*var objAuth = JSON.parse(rootState.objAuthorize);
	var branchDetails = { id: payload.branchId };
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Branch.php?a=remove', branchDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			console.log(error);
		}).then(data => {
		if (data == 'success') {
			var snackDetails = { color: 'success', message: 'The branch was removed successfully', display: true };
			commit('setSnack', snackDetails);
			commit('fncEmptyBranches');
			dispatch({
				type: 'fncPopulateBranches',
				refresh: true
			});
		} else {
			var snackDetails = { color: 'error', message: 'An error has occured removing the branch', display: true };
			commit('setSnack', snackDetails);
		}
	});*/
};

export const fncPopulateBranchesEdit = ({ commit, dispatch, state, rootState }, payload) => {

    var objAuth = JSON.parse(rootState.objAuthorize);
    var branchDetails = { manu_id: objAuth.manufacturer };

    Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Branch.php?a=retrieve', branchDetails, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        console.log(error);
      }).then(data => {

        commit({
          type: 'setObjBranchEdit',
          branchId: payload.branchId,
          regions: payload.regions,
          data: data
        });
        var modalDetails = { title: 'Edit Store - ' + payload.name, component: 'modal-branch-edit', mstate: true };
        commit({
          type: 'setModal',
          details: modalDetails
        });
    });

};
